import { Registry } from '@grafana/data';
import { BINARY_OPERATIONS_KEY } from './types.js';

class QueryModellerBase {
  constructor(operationDefinitions, innerQueryPlaceholder) {
    this.categories = [];
    this.operationsRegistry = new Registry(() => operationDefinitions);
    this.innerQueryPlaceholder = innerQueryPlaceholder || "<query>";
  }
  setOperationCategories(categories) {
    this.categories = categories;
  }
  getOperationsForCategory(category) {
    return this.operationsRegistry.list().filter((op) => op.category === category && !op.hideFromList);
  }
  getAlternativeOperations(key) {
    return this.operationsRegistry.list().filter((op) => op.alternativesKey && op.alternativesKey === key);
  }
  getCategories() {
    return this.categories;
  }
  getOperationDefinition(id) {
    return this.operationsRegistry.getIfExists(id);
  }
  hasBinaryOp(query) {
    return query.operations.find((op) => {
      const def = this.getOperationDefinition(op.id);
      return (def == null ? void 0 : def.category) === BINARY_OPERATIONS_KEY;
    }) !== void 0;
  }
}

export { QueryModellerBase };
//# sourceMappingURL=QueryModellerBase.js.map
